import React from 'react';
import DescribeMealVoiceContainer from './DescribeMealVoiceContainer';
import { TrackerExtractIngredientsConnectorApollo } from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';

const DescribeMealVoicePage = () => {
  const location = useLocation();

  return (
    <TrackerExtractIngredientsConnectorApollo>
      {({ extractIngredients, cancelExtractIngredients }) => (
        <DescribeMealVoiceContainer
          extractIngredients={extractIngredients}
          cancelExtractIngredients={cancelExtractIngredients}
          key={location.key} // Force re-render
        />
      )}
    </TrackerExtractIngredientsConnectorApollo>
  );
};

export default DescribeMealVoicePage;
